import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password updated. Please sign in.");
      navigate("/auth");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F5F7F8] flex flex-col">
      <header className="border-b border-[#D9E1E3] bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Logo size={32} />
            <span className="font-heading font-semibold text-lg">CoParent Console</span>
          </Link>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md border border-[#D9E1E3] bg-white rounded-md p-6 md:p-8" data-testid="reset-card">
          <h1 className="font-heading text-2xl font-semibold">Choose a new password</h1>
          <p className="text-sm text-[#6F828A] mt-1">Enter your new password below. Links are valid for 30 minutes from request.</p>
          {!token ? (
            <div className="mt-6 border border-[#825A41] bg-[#F0E8E3] rounded-sm p-4 text-sm text-[#4A3A2E]" data-testid="reset-no-token">
              This reset link is missing a token. Please request a new link.
              <div className="mt-3"><Link to="/forgot-password" className="underline">Request a new link</Link></div>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="new-pw">New password</Label>
                <PasswordInput id="new-pw" minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="reset-password-input" />
              </div>
              <div>
                <Label htmlFor="new-pw2">Confirm password</Label>
                <PasswordInput id="new-pw2" minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="reset-password-confirm-input" />
              </div>
              <Button type="submit" disabled={busy} className="w-full bg-[#1F9FA4] hover:bg-[#178085] rounded-sm" data-testid="reset-submit-button">
                {busy ? "Updating…" : "Update password"}
              </Button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
